import OutbrainScript from './OutbrainScript'

export default OutbrainScript
